import React from 'react'
import { pick, values } from 'lodash'
import { Link } from 'react-router'

import cn from 'classnames'
import s from './Tag.scss'
import colors from 'styles/colors-export.css'

const getColor = idx => {
  const possibleNames = ['zGreen', 'zRed', 'zPurple', 'zOrange', 'zYellow', 'zLightBlue']
  const possible = values(pick(colors, possibleNames))
  return possible[idx % possible.length]
}

export default props => {
  const { className, style, idx, onClick, children, to, size, ...otherProps } = props
  const styles = Object.assign(
    {},
    idx ? { background: getColor(idx), border: 'none', color: 'white' } : {},
    style
  )
  if (onClick) {
    return (
      <a
        className={cn(s.tag, { [s.xs]: size === 'xs' }, className)}
        style={styles}
        onClick={onClick}
        {...otherProps}
      >
        {children}
      </a>
    )
  }
  if (to) {
    return (
      <Link
        className={cn(s.tag, { [s.xs]: size === 'xs' }, className)}
        style={styles}
        to={to}
        {...otherProps}
      >
        {children}
      </Link>
    )
  }
  return (
    <div className={cn(s.tag, { [s.xs]: size === 'xs' }, className)} style={styles} {...otherProps}>
      {children}
    </div>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Tag/Tag.jsx